import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../helpers/api/apiCall";
import { Endpoints } from "../../../utils/Endpoints";

const initialState = {
  token: '',
  isLogged: false,
  loading: false,
  user: {}
};


export const getDashboard = createAsyncThunk("getDashboard", async (_, thunkAPI) => {
  const response = await client.get(Endpoints.CONTENT.DASHBOARD, {
    token: thunkAPI.getState().auth.token,
  });
  return response.data;
});

export const getContentDetail = createAsyncThunk("getContent", async (eventName, thunkAPI) => {
  const response = await client.get(Endpoints.CONTENT.GET_CONTENT+'?eventName='+eventName, {
    token: thunkAPI.getState().auth.token,
  });
  return response.data;
});

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {

  },
  extraReducers(builder) {
    builder.addCase(getDashboard.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getDashboard.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getDashboard.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getContentDetail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getContentDetail.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getContentDetail.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default homeSlice.reducer;
